module.exports = __webpack_public_path__ + "static/Copernicus-BookItalic-366d2218034c918b1b810a14d5bfa192.woff";